import { makeStyles } from "tss-react/mui"
import { lightBlue } from "../../../../mp-core/themes/palette"
import { alpha, iconClasses, listItemIconClasses } from "@mui/material"

export const useStyles = makeStyles()(({ spacing, typography, mixins }) => ({
  text: {
    fontWeight: 500
  },
  listItemButton: {
    padding: spacing(1, 2),
    border: `1px solid transparent`,
    outline: `3px solid transparent`,
    borderRadius: "3px",
    maxHeight: "fit-content",
    color: lightBlue[700],

    "&:hover": {
      backgroundColor: alpha(lightBlue[100], 0.5)
    },

    "&:focus": {
      ...mixins.focusRing.outline,
      borderWidth: "1px",
      backgroundColor: mixins.focusRing.backgroundColor,
      boxShadow: "none  !important"
    },

    [`& .${listItemIconClasses.root}`]: {
      width: "2.25rem",
      minWidth: "unset",
      height: "2.25rem",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginRight: spacing(2),

      [`& .${iconClasses.root}`]: {
        margin: 0
      },

      "& > .material-icons": {
        color: lightBlue[700],
        fontSize: typography.body1.fontSize
      }
    }
  },
  listItemText: {
    margin: 0
  },
  sm: {
    padding: spacing(0, 2)
  }
}))
